import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';

import {
  addMusicLink,
  clearMusicLinkStatus,
} from 'redux/music-links/actions';

import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import './AddMusicLinkForm.css';

const AddMusicLinkForm = ({
  handleSubmit,
  valid,
  reset,
  url,
  addMusicLinkSuccess,
  addMusicLinkError,
  addMusicLink,
  clearMusicLinkStatus,
}) => {

  useEffect(() => {
    return () => clearMusicLinkStatus();
  }, []);

  const _handleSubmit = values => {
    addMusicLink(values.url);
    reset();
    clearMusicLinkStatus();
  };

  return (
    <Translation>
      {(t) => (
        <div className="add-music-link-form__component">
          <Form
            onSubmit={handleSubmit(_handleSubmit)}
            error={!valid}
          >
            {/* Url */}
            <div className="field-wrapper">
              <div className="icon" />
              <Field
                component={TextField}
                name="url"
                type="text"
                placeholder={t("Paste your link or a ISRC here")}
                required
              />
              <Button
                submit
                disabled={!url || !valid}
              >
                {t("Add")}
              </Button>
            </div>
            <Button
              submit
              disabled={!url || !valid}
            >
              + {t("Add Music Link")}
            </Button>
          </Form>
          {addMusicLinkError &&
            <CommonMessage
              error
              errors={addMusicLinkError}
            />
          }
    
          <CommonMessage warning>
            {t("Music Links feature is in")} <b>{t("BETA")}</b>. {t("We support only")} <b>Apple Music</b>, <b>iTunes</b>, <b>Spotify</b>, <b>Deezer</b> {t("or")} <b>YouTube</b> {t("links at this stage")}
          </CommonMessage>
        </div>
      )}
    </Translation>
  );
};

AddMusicLinkForm.propTypes = {
  handleSubmit: PropTypes.func,
  valid: PropTypes.bool,
  addMusicLinkSuccess: PropTypes.object,
  addMusicLinkError: PropTypes.object,
  reset: PropTypes.func,
  addMusicLink: PropTypes.func,
  clearMusicLinkStatus: PropTypes.func,
  url: PropTypes.string,
};
AddMusicLinkForm.defaultProps = {
  handleSubmit: null,
  valid: false,
  addMusicLinkSuccess: null,
  addMusicLinkError: null,
  reset: null,
  addMusicLink: null,
  clearMusicLinkStatus: null,
  url: null,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('AddMusicLinkForm');
  return {
    url: selector(state, 'url'),
    addMusicLinkSuccess: state.musicLinksReducer.addMusicLinkSuccess,
    addMusicLinkError: state.musicLinksReducer.addMusicLinkError,
  };
};

export default connect(
  mapStateToProps,
  {
    addMusicLink,
    clearMusicLinkStatus,
  },
)(reduxForm({
  form: 'AddMusicLinkForm',
})(AddMusicLinkForm));
